// Generated by Melange

import * as Buhta_cabinet__VerigramWrapper from "../../../util/bindings/VerigramWrapper.js";
import * as Buhta_components__Text from "../../../../../../packages/components/src/html/Text.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as ReactHelmetAsync from "react-helmet-async";
import * as JsxRuntime from "react/jsx-runtime";

function IdentFaceScanPanel(Props) {
  let sessionId = Props.sessionId;
  let accessToken = Props.accessToken;
  let actionId = Props.actionId;
  let actionType = Props.actionType;
  let onScanFinish = Props.onScanFinish;
  React.useEffect((function () {
    const veriliveTimeout = setTimeout((function (param) {
      Buhta_cabinet__VerigramWrapper.launchLivenessScript(sessionId, accessToken, actionId, actionType, onScanFinish);
    }), 2000);
    return (function (param) {
      clearTimeout(veriliveTimeout);
    });
  }), []);
  return JsxRuntime.jsxs(React.Fragment, {
    children: [
      JsxRuntime.jsx(ReactHelmetAsync.Helmet, {
        children: JsxRuntime.jsx("script", {
          src: "https://s3.eu-central-1.amazonaws.com/verilive-statics.verigram.ai/verilive-v1.16.x.js"
        })
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("img", {
                className: "w-[48px] h-[50px]",
                alt: "id",
                src: StaticAsset.src("/static/icons/scan-face-gray.svg")
              }),
              JsxRuntime.jsx(Buhta_components__Text.H4.make, {
                className: "mt-4",
                children: "Сканирование лица"
              })
            ],
            className: "flex flex-col items-center mb-10"
          }),
          JsxRuntime.jsx("div", {
            id: "id_verilive"
          })
        ],
        className: "bg-white shadow-kkm w-[684px] px-10 py-20 rounded-md mt-16 min-h-[630px]"
      })
    ]
  });
}

const make = IdentFaceScanPanel;

export {
  make,
}
/* Buhta_cabinet__VerigramWrapper Not a pure module */
